// extracted by mini-css-extract-plugin
export default {"toast":"toasts_toast__8lIoJ"};